<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-document">Project Info</i>
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <el-row>
                <el-col :span="24" class="searchbar">
                    <el-col :span="3">
                        <label class="searchtitle">Project</label>
                        <el-select v-model="selectprojectvalue" filterable placeholder="please select">
                            <el-option
                            v-for="item in selectprojectoptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="3">
                        <label class="searchtitle">Platform</label>
                        <el-select v-model="selectplatformvalue" filterable placeholder="please select">
                            <el-option
                            v-for="item in selectplatformoptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="3">
                        <label class="searchtitle">SPM</label>
                        <el-select v-model="selectspmvalue" filterable placeholder="please select">
                            <el-option
                            v-for="item in selectspmoptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="3">
                        <label class="searchtitle">PPM</label>
                        <el-select v-model="selectppmvalue" filterable placeholder="please select">
                            <el-option
                            v-for="item in selectppmoptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="3">
                        <label class="searchtitle">Brand</label>
                        <el-select v-model="selectbrandvalue" filterable placeholder="please select">
                            <el-option
                            v-for="item in selectbrandoptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="3">
                        <label class="searchtitle">Battery Model</label>
                        <el-select v-model="selectBatteryModelvalue" filterable placeholder="please select">
                            <el-option
                            v-for="item in selectBatteryModeloptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="6" style="margin-top:20px;">
                        <el-button size="small" type="success" style="margin-left:5px;" @click="searchprojectInfo">S E A R C H</el-button>
                        <el-button size="small" type="info" @click="clearprojectInfo">C L E A R</el-button>
                    </el-col>
                </el-col>
                <el-col :span="24">
                    <el-button size="small" type="warning" icon="el-icon-circle-plus" v-if="group == 'overseamanager.perm_level_high' || group == 'overseamanager.perm_level_middle'" @click="dialogAddNewprojectinfoVisible = true">ADD NEW</el-button>
                    <el-dialog title="ADD NEW PROJECT INFO" :visible.sync="dialogAddNewprojectinfoVisible">
                        <el-form label-position="left" label-width="150px" class="AddNewprojectinfoForm">
                            <el-form-item label="project">
                                <el-input v-model="AddNewprojectinfoFormproject" placeholder="Please Enter project"></el-input>
                            </el-form-item>
                            <el-form-item label="PCB">
                                <el-input v-model="AddNewprojectinfoFormPCB" placeholder="Please Enter PCB"></el-input>
                            </el-form-item>
                            <el-form-item label="Platform">
                                <el-input v-model="AddNewprojectinfoFormPlatform" placeholder="Please Enter Platform"></el-input>
                            </el-form-item>
                            <el-form-item label="PL">
                                <el-input v-model="AddNewprojectinfoFormPL" placeholder="Please Enter PL Email"></el-input>
                            </el-form-item>
                            <el-form-item label="TPM">
                                <el-input v-model="AddNewprojectinfoFormTPM" placeholder="Please Enter TPM Email"></el-input>
                            </el-form-item>
                            <el-form-item label="PPM">
                                <el-input v-model="AddNewprojectinfoFormPPM" placeholder="Please Enter PPM Email"></el-input>
                            </el-form-item>
                            <el-form-item label="SPM">
                                <el-input v-model="AddNewprojectinfoFormSPM" placeholder="Please Enter SPM Email"></el-input>
                            </el-form-item>
                            <el-form-item label="Flash Tool">
                                <el-select style="width:100%" v-model="AddNewprojectinfoFormFlashTool" filterable placeholder="please select">
                                    <el-option
                                    v-for="item in selectFlashTooloptions"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="Battery Model">
                                <el-input v-model="AddNewprojectinfoFormBatteryModel" placeholder="Please Enter Battery Model"></el-input>
                            </el-form-item>
                            <el-form-item label="Type">
                                <el-input v-model="AddNewprojectinfoFormType" placeholder="Please Enter Type"></el-input>
                            </el-form-item>
                            <el-form-item label="Brand">
                                <el-input v-model="AddNewprojectinfoFormBrand" placeholder="Please Enter Brand"></el-input>
                            </el-form-item>
                        </el-form>
                        <div slot="footer" class="dialog-footer">
                            <el-button @click="dialogAddNewprojectinfoVisible = false">Cancel</el-button>
                            <el-button type="primary" @click="AddNewprojectinfo">OK</el-button>
                        </div>
                    </el-dialog>
                    <el-table
                        ref="projectInfoTable"
                        v-loading="loading"
                        element-loading-text="拼命加载中"
                        element-loading-spinner="el-icon-loading"
                        element-loading-background="rgba(0, 0, 0, 0.8)"
                        :data="tableData.slice((currentpage-1)*pagesize,currentpage*pagesize)"
                        border
                        stripe
                        tooltip-effect="dark"
                        style="width: 100%"
                        @selection-change="handleSelectionChange">
                        <!-- <el-table-column
                            type="selection"
                            min-width="2%">
                        </el-table-column> -->
                        <el-table-column
                            prop="id"
                            label="ID"
                            v-if="idshow"
                            align="center"
                            min-width="5%">
                        </el-table-column>
                        <el-table-column
                            prop="project"
                            label="project"
                            align="center"
                            min-width="10%"
                            :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                            prop="PCB"
                            label="PCB"
                            align="center"
                            min-width="10%"
                            :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                            prop="Platform"
                            label="Platform"
                            align="center"
                            min-width="10%"
                            :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                            prop="projectleader"
                            label="PL"
                            align="center"
                            min-width="10%"
                            :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                            prop="tpm"
                            label="TPM"
                            align="center"
                            min-width="10%"
                            :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                            prop="ppm"
                            label="PPM"
                            align="center"
                            min-width="10%"
                            :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                            prop="SPM"
                            label="SPM"
                            align="center"
                            min-width="10%"
                            :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                            prop="flashtool"
                            label="Flash Tool"
                            align="center"
                            min-width="10%"
                            :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                            prop="BatteryModel"
                            label="Battery Model"
                            align="center"
                            min-width="10%"
                            :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                            prop="Type"
                            label="Type"
                            align="center"
                            min-width="10%"
                            :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                            prop="brand"
                            label="Brand"
                            align="center"
                            min-width="10%"
                            :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column 
                            fixed="right"
                            label="Operation"
                            align="center"
                            v-if="group == 'overseamanager.perm_level_high' || group == 'overseamanager.perm_level_middle'"
                            min-width="13%">
                            <template slot-scope="scope">
                                <el-button
                                    size="mini"
                                    @click="dialogEditprojectinfoVisible = true;handleEdit(scope.$index, scope.row);">Edit</el-button>
                                <el-button
                                    size="mini"
                                    type="danger"
                                    @click="handleDelete(scope.$index, scope.row)">Delete</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-dialog title="EDIT PROJECT INFO" :visible.sync="dialogEditprojectinfoVisible">
                        <el-form label-position="left" label-width="150px" class="EditprojectinfoForm">
                            <el-form-item label="project">
                                <el-input v-model="EditprojectinfoFormproject" placeholder="Please Enter project"></el-input>
                            </el-form-item>
                            <el-form-item label="PCB">
                                <el-input v-model="EditprojectinfoFormPCB" placeholder="Please Enter PCB"></el-input>
                            </el-form-item>
                            <el-form-item label="Platform">
                                <el-input v-model="EditprojectinfoFormPlatform" placeholder="Please Enter Platform"></el-input>
                            </el-form-item>
                            <el-form-item label="PL">
                                <el-input v-model="EditprojectinfoFormPL" placeholder="Please Enter PL Email"></el-input>
                            </el-form-item>
                            <el-form-item label="TPM">
                                <el-input v-model="EditprojectinfoFormTPM" placeholder="Please Enter TPM Email"></el-input>
                            </el-form-item>
                            <el-form-item label="PPM">
                                <el-input v-model="EditprojectinfoFormPPM" placeholder="Please Enter PPM Email"></el-input>
                            </el-form-item>
                            <el-form-item label="SPM">
                                <el-input v-model="EditprojectinfoFormSPM" placeholder="Please Enter SPM Email"></el-input>
                            </el-form-item>
                            <el-form-item label="Flash Tool">
                                <el-select style="width:100%" v-model="EditprojectinfoFormFlashTool" filterable placeholder="please select">
                                    <el-option
                                    v-for="item in selectFlashTooloptions"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="Battery Model">
                                <el-input v-model="EditprojectinfoFormBatteryModel" placeholder="Please Enter Battery Model"></el-input>
                            </el-form-item>
                            <el-form-item label="Type">
                                <el-input v-model="EditprojectinfoFormType" placeholder="Please Enter Type"></el-input>
                            </el-form-item>
                            <el-form-item label="Brand">
                                <el-input v-model="EditprojectinfoFormBrand" placeholder="Please Enter Brand"></el-input>
                            </el-form-item>
                        </el-form>
                        <div slot="footer" class="dialog-footer">
                            <el-button @click="dialogEditprojectinfoVisible = false">Cancel</el-button>
                            <el-button type="primary" @click="Editprojectinfo">OK</el-button>
                        </div>
                    </el-dialog>
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="currentpage"
                        :page-sizes="[8, 15, 30, 50]"
                        :page-size="pagesize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="currentTotal"
                        >
                    </el-pagination>
                    <!-- <div style="margin-top: 20px">
                        <el-button @click="ClearSelection">cancel选择</el-button>
                        <el-button @click="AllSelection">全选</el-button>
                    </div> -->
                </el-col>
            </el-row>
        </div>    
    </div>
</template>

<script>
import { searchprojectInfoData,AddNewprojectinfoData,EditprojectinfoData,DeleteProjectInfoData,GetProjectInfoSelectOption,GetFlashToolSelectOption } from '../../api/index';
export default {
    name: 'basetable',
    data() {
        return {
            group:"",
            currentpage: 1,
            pagesize: 8,
            currentTotal: 0,
            tableData: [],
            multipleSelection: [],
            loading: false,            
            idshow: false,
            selectprojectoptions: [],
            selectprojectvalue: '',
            selectplatformoptions: [],
            selectplatformvalue: '',
            selectspmoptions: [],
            selectspmvalue: '',
            selectppmoptions: [],
            selectppmvalue: '',
            selectbrandoptions: [],
            selectbrandvalue: '',
            selectBatteryModeloptions: [],
            selectBatteryModelvalue: '',
            selectFlashTooloptions: [],
            dialogAddNewprojectinfoVisible:false,
            AddNewprojectinfoFormproject: '',
            AddNewprojectinfoFormPCB: '',
            AddNewprojectinfoFormPlatform: '',
            AddNewprojectinfoFormPL: '',
            AddNewprojectinfoFormTPM: '',
            AddNewprojectinfoFormPPM: '',
            AddNewprojectinfoFormSPM: '',
            AddNewprojectinfoFormFlashTool: '',
            AddNewprojectinfoFormBatteryModel: '',
            AddNewprojectinfoFormType: '',
            AddNewprojectinfoFormBrand: '',
            dialogEditprojectinfoVisible:false,
            EditprojectinfoFormid: '',
            EditprojectinfoFormproject: '',
            EditprojectinfoFormPCB: '',
            EditprojectinfoFormPlatform: '',
            EditprojectinfoFormPL: '',
            EditprojectinfoFormTPM: '',
            EditprojectinfoFormPPM: '',
            EditprojectinfoFormSPM: '',
            EditprojectinfoFormFlashTool: '',
            EditprojectinfoFormBatteryModel: '',
            EditprojectinfoFormType: '',
            EditprojectinfoFormBrand: '',
        };
    },
    created() {
        this.group = localStorage.getItem("Group");
        let token = this.$store.getters.idToken;
        searchprojectInfoData ({
            project: "",
            SPM: "",
            ppm: "",
            brand: "",
            Platform: "",
            BatteryModel: "",
        },token).then(res => {
            console.log(res);
            this.tableData = res.results;
            this.currentTotal = res.results.length;
        }).catch(error => console.log(error));
        GetProjectInfoSelectOption (token).then(res => {
            console.log(res);
            this.selectprojectoptions = res.project;
            this.selectplatformoptions = res.Platform;
            this.selectspmoptions = res.SPM;
            this.selectppmoptions = res.ppm;
            this.selectbrandoptions = res.brand;
            this.selectBatteryModeloptions = res.BatteryModel;
        }).catch(error => console.log(error));
        GetFlashToolSelectOption (token).then(res => {
            console.log(res,"aaa");
            this.selectFlashTooloptions = res.flashtool
        }).catch(error => console.log(error));
    },
    methods: {
        handleSizeChange(val) {
        this.pagesize = val;
        console.log(`每页 ${val} 条`);
        },
        handleCurrentChange(val) {
            this.currentpage = val;
            console.log(`当前页: ${val}`);
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
            console.log(this.multipleSelection);
        },
        handleEdit(index, row) {
            console.log(index, row);
            this.EditprojectinfoFormid = row.id,
            this.EditprojectinfoFormproject = row.project,
            this.EditprojectinfoFormPCB = row.PCB,
            this.EditprojectinfoFormPlatform = row.Platform,
            this.EditprojectinfoFormPL = row.projectleader,
            this.EditprojectinfoFormTPM = row.tpm,
            this.EditprojectinfoFormPPM = row.ppm,
            this.EditprojectinfoFormSPM = row.SPM,
            this.EditprojectinfoFormFlashTool = row.flashtool,
            this.EditprojectinfoFormBatteryModel = row.BatteryModel,
            this.EditprojectinfoFormType = row.Type,
            this.EditprojectinfoFormBrand = row.brand
        },
        handleDelete(index, row) {
            let token = this.$store.getters.idToken;
            console.log(index, row);
            console.log(row.id);
            this.$confirm('此Operation将永久Delete该文件, 是否继续?', '提示', {
                confirmButtonText: 'OK',
                cancelButtonText: 'cancel',
                type: 'warning'
            }).then(() => {
                DeleteProjectInfoData ({
                    id: row.id
                },token).then(res => {
                    console.log(res);
                    this.tableData.splice(((this.currentpage-1)*this.pagesize+index), 1);
                    this.currentTotal--;
                    this.$message({
                        type: 'success',
                        message: 'Delete successful'
                    });
                    GetProjectInfoSelectOption (token).then(res => {
                        console.log(res);
                        this.selectprojectoptions = res.project;
                        this.selectplatformoptions = res.Platform;
                        this.selectspmoptions = res.SPM;
                        this.selectppmoptions = res.ppm;
                        this.selectbrandoptions = res.brand;
                        this.selectBatteryModeloptions = res.BatteryModel;
                    }).catch(error => console.log(error));
                }).catch(error => console.log(error));
            }).catch(() => {
                this.$message({
                    type: 'warning',
                    message: 'Delete canceled'
                });          
            });
        },
        searchprojectInfo () {
            let token = this.$store.getters.idToken;
            this.loading = true;
            searchprojectInfoData ({
                project: this.selectprojectvalue,
                SPM: this.selectspmvalue,
                ppm: this.selectppmvalue,
                brand: this.selectbrandvalue,
                Platform: this.selectplatformvalue,
                BatteryModel: this.selectBatteryModelvalue
            },token).then(res => {
                this.tableData = res.results;
                this.currentTotal = res.results.length;
                this.loading = false;
            }).catch(error => console.log(error));
            GetProjectInfoSelectOption (token).then(res => {
                console.log(res);
                this.selectprojectoptions = res.project;
                this.selectplatformoptions = res.Platform;
                this.selectspmoptions = res.SPM;
                this.selectppmoptions = res.ppm;
                this.selectbrandoptions = res.brand;
                this.selectBatteryModeloptions = res.BatteryModel;
            }).catch(error => console.log(error));
            },
        clearprojectInfo () {
            let token = this.$store.getters.idToken;
            this.selectprojectvalue = "";
            this.selectspmvalue = "";
            this.selectppmvalue = "";
            this.selectbrandvalue = "";
            this.selectplatformvalue = "";
            this.selectBatteryModelvalue = "";
            this.loading = true;
            searchprojectInfoData ({
                project: "",
                spm: "",
                ppm: "",
                brand: "",
                platform: "",
                BatteryModel: "",
            },token).then(res => {
                this.tableData = res.results;
                this.currentTotal = res.results.length;
                this.loading = false;
            }).catch(error => console.log(error));
            GetProjectInfoSelectOption (token).then(res => {
                console.log(res);
                this.selectprojectoptions = res.project;
                this.selectplatformoptions = res.Platform;
                this.selectspmoptions = res.SPM;
                this.selectppmoptions = res.ppm;
                this.selectbrandoptions = res.brand;
                this.selectBatteryModeloptions = res.BatteryModel;
            }).catch(error => console.log(error));
        },
        AddNewprojectinfo() {
            let token = this.$store.getters.idToken;
            const AddNewprojectinfoFormData = {
                project: this.AddNewprojectinfoFormproject,
                PCB: this.AddNewprojectinfoFormPCB,
                Platform: this.AddNewprojectinfoFormPlatform,
                projectleader: this.AddNewprojectinfoFormPL,
                tpm: this.AddNewprojectinfoFormTPM,
                ppm: this.AddNewprojectinfoFormPPM,
                SPM: this.AddNewprojectinfoFormSPM,
                flashtool: this.AddNewprojectinfoFormFlashTool,
                BatteryModel: this.AddNewprojectinfoFormBatteryModel,
                Type: this.AddNewprojectinfoFormType,
                brand: this.AddNewprojectinfoFormBrand
            }
            AddNewprojectinfoData (AddNewprojectinfoFormData,token).then(res => {
                if (res != "") {
                    console.log(res);
                    console.log(this.tableData);
                    const AddNewItemRes = {
                        project: this.AddNewprojectinfoFormproject,
                        PCB: this.AddNewprojectinfoFormPCB,
                        Platform: this.AddNewprojectinfoFormPlatform,
                        projectleader: this.AddNewprojectinfoFormPL,
                        tpm: this.AddNewprojectinfoFormTPM,
                        ppm: this.AddNewprojectinfoFormPPM,
                        SPM: this.AddNewprojectinfoFormSPM,
                        flashtool: this.AddNewprojectinfoFormFlashTool,
                        BatteryModel: this.AddNewprojectinfoFormBatteryModel,
                        Type: this.AddNewprojectinfoFormType,
                        brand: this.AddNewprojectinfoFormBrand
                    };
                    this.tableData.push(AddNewItemRes);
                    this.currentTotal++;
                    this.$message({
                        message: 'Added successfully',
                        type: 'success'
                    });
                    GetProjectInfoSelectOption (token).then(res => {
                        console.log(res);
                        this.selectprojectoptions = res.project;
                        this.selectplatformoptions = res.Platform;
                        this.selectspmoptions = res.SPM;
                        this.selectppmoptions = res.ppm;
                        this.selectbrandoptions = res.brand;
                        this.selectBatteryModeloptions = res.BatteryModel;
                    }).catch(error => console.log(error));
                    this.AddNewprojectinfoFormproject = "";
                    this.AddNewprojectinfoFormPCB = "";
                    this.AddNewprojectinfoFormPlatform = "";
                    this.AddNewprojectinfoFormPL = "";
                    this.AddNewprojectinfoFormTPM = "";
                    this.AddNewprojectinfoFormPPM = "";
                    this.AddNewprojectinfoFormSPM = "";
                    this.AddNewprojectinfoFormFlashTool = "";
                    this.AddNewprojectinfoFormBatteryModel = "";
                    this.AddNewprojectinfoFormType = "";
                    this.AddNewprojectinfoFormBrand = "";
                    this.dialogAddNewprojectinfoVisible = false;                    
                }
            }).catch(() => {
                this.$message({
                    type: 'warning',
                    message: 'Sorry, failed to add'
                });          
            });
        },
        Editprojectinfo() {
            let token = this.$store.getters.idToken;
            const EditprojectinfoFormData = {
                id : this.EditprojectinfoFormid,
                project: this.EditprojectinfoFormproject,
                PCB: this.EditprojectinfoFormPCB,
                Platform: this.EditprojectinfoFormPlatform,
                projectleader: this.EditprojectinfoFormPL,
                tpm: this.EditprojectinfoFormTPM,
                ppm: this.EditprojectinfoFormPPM,
                SPM: this.EditprojectinfoFormSPM,
                flashtool: this.EditprojectinfoFormFlashTool,
                BatteryModel: this.EditprojectinfoFormBatteryModel,
                Type: this.EditprojectinfoFormType,
                brand: this.EditprojectinfoFormBrand
            }
            EditprojectinfoData (this.EditprojectinfoFormid,EditprojectinfoFormData,token).then(res => {
                if (res != "") {
                     this.$message({
                        message: '恭喜你，Modified successfully',
                        type: 'success'
                    });
                    for (var i = 0;i < this.tableData.length;i++) {
                        if (this.EditprojectinfoFormid == this.tableData[i].id) {
                            this.tableData[i].project = EditprojectinfoFormData.project;
                            this.tableData[i].PCB = EditprojectinfoFormData.PCB;
                            this.tableData[i].Platform = EditprojectinfoFormData.Platform;
                            this.tableData[i].projectleader = EditprojectinfoFormData.projectleader;
                            this.tableData[i].tpm = EditprojectinfoFormData.tpm;
                            this.tableData[i].ppm = EditprojectinfoFormData.ppm;
                            this.tableData[i].SPM = EditprojectinfoFormData.SPM;
                            this.tableData[i].flashtool = EditprojectinfoFormData.flashtool;
                            this.tableData[i].BatteryModel = EditprojectinfoFormData.BatteryModel;
                            this.tableData[i].Type = EditprojectinfoFormData.Type;
                            this.tableData[i].brand = EditprojectinfoFormData.brand;
                            console.log(this.tableData[i]);
                        }
                    }
                    GetProjectInfoSelectOption (token).then(res => {
                        console.log(res);
                        this.selectprojectoptions = res.project;
                        this.selectplatformoptions = res.Platform;
                        this.selectspmoptions = res.SPM;
                        this.selectppmoptions = res.ppm;
                        this.selectbrandoptions = res.brand;
                        this.selectBatteryModeloptions = res.BatteryModel;
                    }).catch(error => console.log(error));
                    this.dialogEditprojectinfoVisible = false;
                }
            }).catch(() => {
                this.$message({
                    type: 'warning',
                    message: '很遗憾，Sorry, modify failed'
                });          
            });
        }
    }
};
</script>

<style scoped>
    .searchtitle {
        font-family: Arial, Helvetica, sans-serif;
        font-weight: bold;
        font-size: 16px;
        margin-right: 10px;
    }
    .searchbar {
        padding: 20px 0px;
        margin-top:-30px;
    }
    .AddNewprojectinfoForm {
        font-weight: bold;
        font-size: 16px;
    }
</style>
